import { PrintView } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React, { ReactElement } from 'react';

import styles from './UpgradeToPrint.module.scss';

const cx = classNames.bind(styles);

const UpgradeToPrint = (): ReactElement => {
  return (
    <PrintView>
      <div className={cx('body')} data-testid="upgrade-to-print">
        <div className={cx('header')}>
          Downloads are available under our premium plan. Contact your account representative to learn more
        </div>
      </div>
    </PrintView>
  );
};

export default UpgradeToPrint;
